/** Detecção robusta de gamepads (Stadia, DualSense, Xbox, etc.). */

export function isStadiaController(id) {
  return /stadia/i.test(id);
}

export function shortPadLabel(id) {
  if (isStadiaController(id)) return 'Stadia Controller';
  if (/dualsense|wireless controller/i.test(id)) return 'DualSense';
  if (/xbox|x-input|microsoft/i.test(id)) return 'Xbox';
  return id.length > 48 ? `${id.slice(0, 45)}…` : id;
}

/** Chrome só expõe gamepads depois de premir um botão — polling é obrigatório. */
export function listConnectedGamepads() {
  if (!navigator.getGamepads) return [];
  const pads = [];
  const raw = navigator.getGamepads();
  for (let i = 0; i < raw.length; i++) {
    const gp = raw[i];
    if (gp && gp.connected) pads.push({ index: gp.index, id: gp.id, gp });
  }
  return pads;
}

export function formatGamepadStatus(pads) {
  if (!navigator.getGamepads) {
    return 'Comando: este browser não suporta Gamepad API. Usa Chrome ou Firefox.';
  }
  if (!pads.length) {
    return (
      'Comando: nenhum — liga o Stadia (USB ou Bluetooth), clica na página e prime QUALQUER botão. ' +
      'No Linux: utilizador no grupo input ou regras udev (ver consola do servidor).'
    );
  }
  const labels = pads.map((p) => shortPadLabel(p.id)).join(' · ');
  const stadia = pads.some((p) => isStadiaController(p.id));
  const hint = stadia
    ? 'Stadia detectado — os controlos ficam guardados por consola.'
    : 'Os controlos ficam guardados por consola após configurares no menu do emulador.';
  return `Comando: ${labels} — ${hint}`;
}

/** Foca a área do emulador para o browser associar o gamepad ao jogo. */
export function focusEmulatorSurface() {
  const root = document.querySelector('#game');
  if (!root) return;
  const target = root.querySelector('canvas') || root;
  if (target instanceof HTMLElement) {
    target.setAttribute('tabindex', '0');
    target.focus({ preventScroll: true });
  }
}

/** Mapeamento Stadia → layout SNES/RetroArch usado pelo EmulatorJS (value2). */
export const STADIA_EJS_CONTROLS = {
  0: {
    0: { value: 'x', value2: 'BUTTON_2' },
    1: { value: 's', value2: 'BUTTON_4' },
    2: { value: 'v', value2: 'SELECT' },
    3: { value: 'Enter', value2: 'START' },
    4: { value: 'ArrowUp', value2: 'DPAD_UP' },
    5: { value: 'ArrowDown', value2: 'DPAD_DOWN' },
    6: { value: 'ArrowLeft', value2: 'DPAD_LEFT' },
    7: { value: 'ArrowRight', value2: 'DPAD_RIGHT' },
    8: { value: 'z', value2: 'BUTTON_1' },
    9: { value: 'a', value2: 'BUTTON_3' },
    10: { value: 'q', value2: 'LEFT_TOP_SHOULDER' },
    11: { value: 'e', value2: 'RIGHT_TOP_SHOULDER' },
    12: { value: 'Tab', value2: 'LEFT_BOTTOM_SHOULDER' },
    13: { value: 'r', value2: 'RIGHT_BOTTOM_SHOULDER' },
  },
  1: {},
  2: {},
  3: {},
};

export function pickDefaultControls() {
  const pads = listConnectedGamepads();
  if (pads.some((p) => isStadiaController(p.id))) return STADIA_EJS_CONTROLS;
  return null;
}
